import { makeStyles, Button } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { dataService } from '../../../Services/data.service';
import { toast } from 'react-toastify';
import BackForwardButton from '../../Shared/BackForwardButton';
import { NavLink } from "react-router-dom";
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import QualityChecksFilter from '../../QualityCheck/QualityChecksFilter'
import NewQualityCheckDrawer from '../../QualityCheck/NewQualityCheckDrawer'
import moment from 'moment'
import { useTranslation } from 'react-i18next';

export default function QualityChecksPage(props) {
    const classes = useStyles();

    const [qualityChecks, setQualityChecks] = useState([]);
    const [order, setOrder] = useState(null)
    const [operators, setOperators] = useState([])
    const [filteredOperators, setFilteredOperators] = useState([])
    const [fromDate, setFromDate] = useState(new Date())
    const [tillDate, setTillDate] = useState(new Date())
    const [filtered, setFiltered] = useState(false)
    const [dataFetched, setDataFetched] = useState(false)
    const [newQualityCheckDrawerOpen, setNewQualityCheckDrawerOpen] = useState(false);
    const { t } = useTranslation();

    const rows = qualityChecks.map(check => createData(check.id, check.date, check.operator, check.producedPieces, check.withinTolerance))

    const firstCheck = rows[0]
    const lastCheck = rows[rows.length - 1]

    useEffect(() => {
        let mounted = true
        dataService.getQualityChecksByOrderId(props.match.params.id).then(checks => {
            if (mounted) {
                if (qualityChecks.length !== checks.body.length) {
                    setQualityChecks(checks.body)
                }
                setDataFetched(true)
            }
        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

        dataService.getOperators().then(operatoren => {
            if (mounted) {
                if (operators.length !== operatoren.body.length) {
                    setOperators(operatoren.body)
                }
            }
        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

        let order = props.order.productionOrders.find(order => String(order.id) === props.match.params.id)
        setOrder(order)

        return function cleanup() {
            mounted = false
        }
    }, [operators, qualityChecks, filteredOperators, props.match.params.id, props.order.productionOrders]);

    function createData(id, date, operator, producedPieces, withinTolerance) {

        let tempDate = (moment(date, "DD-MM-YYYY")._d)

        if (tempDate < fromDate || tempDate > tillDate) {
            if (filtered) {
                return null;
            }
        }

        if (filtered) {
            if (filteredOperators.length !== 0) {
                if (filteredOperators.findIndex(x => x.name === operator) === -1) {
                    return null;
                }
            }
        }

        producedPieces = producedPieces + "/" + order.pieces

        return { id, date, operator, producedPieces, withinTolerance };
    }

    function updateDates(fromDate, tillDate) {
        setFromDate(fromDate)
        setTillDate(tillDate)
        setFiltered(true)
    }

    function updateOperators(operator) {
        var tempFilteredOperators = Object.assign([], filteredOperators);
        let index = filteredOperators.findIndex(x => x.name === operator.name);
        if (index === -1) {
            tempFilteredOperators.push(operator)
        }
        else {
            tempFilteredOperators.splice(index, 1)
        }

        setFilteredOperators(tempFilteredOperators)
        setFiltered(true)
    }

    const openNewQualityCheckDrawer = (open) => {
        setNewQualityCheckDrawerOpen(open);
    }

    if (firstCheck) {
        let firstDate = moment(firstCheck.date, "DD-MM-YYYY")._d
        if (fromDate.toString() !== firstDate.toString()) {
            setFromDate(firstDate)
        }
    }
    if (lastCheck) {
        let lastDate = moment(lastCheck.date, "DD-MM-YYYY")._d
        if (tillDate.toString() !== lastDate.toString()) {
            setTillDate(lastDate)
        }
    }

    return (
        <React.Fragment>
            <div className={classes.background}>
                <div className={classes.filterBar}>
                    {dataFetched ? <QualityChecksFilter operators={operators} updatedates={updateDates} updateoperators={updateOperators} firstdate={fromDate} lastdate={tillDate}></QualityChecksFilter> : <React.Fragment></React.Fragment>}
                </div>
                <div className={classes.qualityChecks}>
                    <div className={classes.header}>
                        <div className={classes.left}>
                            <div className={classes.back}>
                                <NavLink className={classes.navButton} to={`/order/${props.match.params.id}`}>
                                    {order ? <BackForwardButton textOverride={t("Back to order") + " " + order.ordernumber} direction={'Back'}></BackForwardButton> : <BackForwardButton direction={'Back'}></BackForwardButton>}
                                </NavLink>
                            </div>
                            <div className={classes.title}>
                                {t("Quality checks")}
                            </div>
                        </div>
                        <div className={classes.right}>
                            <Button className={classes.newQualityCheckButton} onClick={() => openNewQualityCheckDrawer(true)}>
                                <AddRoundedIcon className={classes.addIcon}></AddRoundedIcon>
                                <div className={classes.buttonText}>{t("NEW QUALITY CHECK")}</div>
                            </Button>
                        </div>
                    </div>
                    <div className={classes.qualityChecksTable}>
                        <Table className={classes.table} aria-label="customized table">
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.headCell}>{t("Date")}</TableCell>
                                    <TableCell className={classes.headCell}>Operator</TableCell>
                                    <TableCell className={classes.headCell}>{t("Produced pieces")}</TableCell>
                                    <TableCell className={classes.headCell}>{t("Within tolerance")}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows.filter(x => x !== null).map((row) => (
                                    <TableRow key={row.id} className={classes.row}>
                                        <TableCell className={classes.infoCell}>{row.date}</TableCell>
                                        <TableCell className={classes.infoCell}>{row.operator}</TableCell>
                                        <TableCell className={classes.infoCell}>{row.producedPieces}</TableCell>
                                        <TableCell className={classes.infoCell} align="right">{row.withinTolerance ?
                                            <img className={classes.check} src={process.env.PUBLIC_URL + '/img/greenCheck.svg'} alt={""}></img> :
                                            <svg className={classes.check} xmlns="http://www.w3.org/2000/svg" version="1.1" id="Layer_1" x="0px" y="0px" width="15px" height="15px" viewBox="0 0 121.31 122.876" enableBackground="new 0 0 121.31 122.876"><g><path fillRule="evenodd" fill="#D84949" clipRule="evenodd" d="M90.914,5.296c6.927-7.034,18.188-7.065,25.154-0.068 c6.961,6.995,6.991,18.369,0.068,25.397L85.743,61.452l30.425,30.855c6.866,6.978,6.773,18.28-0.208,25.247 c-6.983,6.964-18.21,6.946-25.074-0.031L60.669,86.881L30.395,117.58c-6.927,7.034-18.188,7.065-25.154,0.068 c-6.961-6.995-6.992-18.369-0.068-25.397l30.393-30.827L5.142,30.568c-6.867-6.978-6.773-18.28,0.208-25.247 c6.983-6.963,18.21-6.946,25.074,0.031l30.217,30.643L90.914,5.296L90.914,5.296z" /></g></svg>
                                        }  </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                </div>
            </div>
            <NewQualityCheckDrawer openDrawer={openNewQualityCheckDrawer} drawerOpen={newQualityCheckDrawerOpen} ></NewQualityCheckDrawer>
        </React.Fragment>
    )
}

const useStyles = makeStyles({
    filterBar: {
        width: "210px",
        backgroundColor: "#DEDEDE",
        float: "left",
        height: "100%",
        padding: "20px",
        paddingLeft: "0px",
        paddingTop: "30px",
        boxSizing: 'border-box'
    },
    qualityChecks: {
        width: "calc(100% - 210px)",
        float: "left",
        height: "100%",
        padding: "15px",
        boxSizing: 'border-box'
    },
    navButton: {
        textDecoration: "none"
    },
    back: {
        display: 'block'
    },
    title: {
        display: 'block',
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
        marginLeft: "5px"
    },
    right: {
        float: 'right'
    },
    left: {
        float: "left"
    },
    newQualityCheckButton: {
        backgroundColor: FlagstoneTheme.palette.primary.main,
        width: "auto",
        height: "40px",
        paddingLeft: "5px !important",
        marginTop: "20px",
        "&:hover": {
            background: FlagstoneTheme.palette.primary.main
        }
    },
    addIcon: {
        color: "white",
        float: "left"
    },
    buttonText: {
        color: 'white',
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        float: "left",
        paddingTop: "2px",
        marginLeft: "2px",
        marginRight: "5px"

    },
    download: {
        marginLeft: "10px"
    },
    check: {
        float: 'left',
        marginLeft: "40px",
        marginTop: "5px"
    },
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: "#F4F4F4",
        },
    },
    qualityChecksTable: {
        backgroundColor: "white",
        padding: "10px",
        borderRadius: "6px",
        marginLeft: "5px"
    },
    header: {
        height: "100px"
    },
    infoCell: {
        color: '#020100',
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        border: "none",
        paddingBottom: "10px",
        paddingTop: "10px"
    },
    headCell: {
        color: '#8D8D8D',
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        border: "none",
        paddingBottom: "0px"
    },
    background:{
        marginTop:"40px",
        height:"100vw"
    }
});